import React from "react";
import { speedToPace } from "../lib/pace";

const fieldCls =
  "w-full bg-transparent border-0 border-b border-[var(--tir-border)] focus:border-[var(--tir-burgundy)] px-0 py-1.5 text-sm font-mono-tir text-[var(--tir-ink)] focus:outline-none";

const labelCls =
  "block text-[10px] tracking-[0.22em] uppercase text-[var(--tir-muted)] font-semibold mb-1";

function ThresholdBlock({ title, subtitle, value, onChange, speedUnit, testId, accent }) {
  const update = (field, v) => {
    const next = { ...(value || {}), [field]: v };
    if (field === "speed") {
      next.pace = speedToPace(v, speedUnit);
    }
    onChange(next);
  };
  return (
    <div
      className="border border-[var(--tir-border)] bg-white p-5"
      data-testid={testId}
      style={{ borderLeft: `3px solid ${accent}` }}
    >
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <div className="font-serif-display text-2xl text-[var(--tir-ink)] leading-none">
            {title}
          </div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-[var(--tir-muted)] mt-1.5">
            {subtitle}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-5 gap-y-3">
        <div>
          <label className={labelCls}>HR (bpm)</label>
          <input
            type="number"
            value={value?.hr ?? ""}
            onChange={(e) => update("hr", e.target.value)}
            className={fieldCls}
            data-testid={`${testId}-hr`}
          />
        </div>
        <div>
          <label className={labelCls}>Speed ({speedUnit})</label>
          <input
            type="number"
            step="0.1"
            value={value?.speed ?? ""}
            onChange={(e) => update("speed", e.target.value)}
            className={fieldCls}
            data-testid={`${testId}-speed`}
          />
        </div>
        <div>
          <label className={labelCls}>Pace (min/km)</label>
          <input
            type="text"
            placeholder="7:37"
            value={value?.pace ?? ""}
            onChange={(e) => update("pace", e.target.value)}
            className={fieldCls}
            data-testid={`${testId}-pace`}
          />
        </div>
        <div>
          <label className={labelCls}>RPE / 10</label>
          <input
            type="number"
            step="0.5"
            value={value?.rpe ?? ""}
            onChange={(e) => update("rpe", e.target.value)}
            className={fieldCls}
            data-testid={`${testId}-rpe`}
          />
        </div>
      </div>
    </div>
  );
}

export default function ThresholdInputs({ lt1, lt2, speedUnit, onChangeLT1, onChangeLT2 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="threshold-inputs">
      <ThresholdBlock
        title="LT1"
        subtitle="Aerobic Threshold"
        value={lt1}
        onChange={onChangeLT1}
        speedUnit={speedUnit}
        testId="lt1-block"
        accent="#1C1917"
      />
      <ThresholdBlock
        title="LT2"
        subtitle="Anaerobic Threshold"
        value={lt2}
        onChange={onChangeLT2}
        speedUnit={speedUnit}
        testId="lt2-block"
        accent="#7A1F2B"
      />
    </div>
  );
}
